import { useState, useEffect } from "react";
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import swal from "sweetalert";
import { MealPlansave, roomlistdetail, SaveRoomdetail } from "../../Services/Service";

const Room = () => {
	const [loading, setLoading] = useState(false);
	const [images, setImages] = useState([]);
	const [rooms, setRooms] = useState([]);
	const [isEditMode, setIsEditMode] = useState(false);
	const [editRoomId, setEditRoomId] = useState(null);


	const fetchRoomData = async () => {
		setLoading(true);
		try {
			const data = await roomlistdetail();
			if (Array.isArray(data)) setRooms(data);

		} catch (error) {
			console.error("Room data fetch error:", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchRoomData();
	}, []);


	const handleImageChange = (e) => {
		const files = Array.from(e.target.files);
		const newImages = files.map(file => ({
			file,
			url: URL.createObjectURL(file)
		}));
		setImages(prev => [...prev, ...newImages]);
	};

	const removeImage = (indexToRemove) => {
		setImages(prev =>
			prev.filter((_, index) => index !== indexToRemove)
		);
	};


	const initialFormData = {
		RoomName: '',
		RoomType: '',
		BedType: '',
		TotalRooms: 1,
		Description: '',
		RoomView: '',
		ExtraBedType: '',
		DimensionsType: '',
		Length: '',
		Breadth: '',
		Area: '',
		Adult_Base: 0,
		Adult_Max: 0,
		Guest_Max: 0,
		Child_Base: 0,
		Child_Max: 0,
	}

	const [formData, setFormData] = useState(initialFormData);

	const handleSubmit = async (e) => {
		setLoading(true);
		e.preventDefault();
		const propertyId = localStorage.getItem("SelectedPropertyID");
		const userId = localStorage.getItem("UserID");

		const roomPayload = {
			RoomID: isEditMode ? editRoomId : 0,
			PropertyID: parseInt(propertyId),
			RoomName: formData.RoomName,
			Description: formData.Description,
			Active: 1,
			CreatedBy: parseInt(userId),
			CreatedDateTime: new Date().toISOString(),
			ModifyBy: parseInt(userId),
			ModifyDateTime: new Date().toISOString(),
			RoomType: formData.RoomType,
			TotalRooms: formData.TotalRooms.toString(),
			RoomView: formData.RoomView,
			BedType: formData.BedType,
			ExtraBedType: formData.ExtraBedType,
			Dimensions: "",
			Length: formData.Length,
			Breadth: formData.Breadth,
			Area: formData.Area,
			DimensionsType: formData.DimensionsType,
			Adult_Base: formData.Adult_Base,
			Adult_Max: formData.Adult_Max,
			Guest_Max: formData.Guest_Max,
			Child_Base: formData.Child_Base,
			Child_Max: formData.Child_Max,
			ExtraBedRate: formData.ExtraBedRate,
			RoomCode: formData.RoomCode
		};

		const imageFile = images.length > 0 ? images[0].file : null;
		console.log("ImageFile in handleSubmit:", imageFile);

		try {
			const response = await SaveRoomdetail(roomPayload, imageFile);
			console.log("room data", response);
			swal(isEditMode ? "Room Updated Successfully" : "Room Added Successfully", {
				icon: "success",
				buttons: {
					confirm: {
						text: "OK",
						className: "btn btn-success",
					},
				},
			});


			const updatedRoom = { ...roomPayload, RoomID: response.RoomID, RatePlanDetails: "[]" };

			const updatedRooms = isEditMode
				? rooms.map(r => (r.RoomID === response.RoomID ? updatedRoom : r))
				: [...rooms, updatedRoom];

			setRooms(updatedRooms);

			// Reset
			setFormData(initialFormData);
			setImages([]);
			setIsEditMode(false);
			setEditRoomId(null);

			const modal = window.bootstrap.Modal.getOrCreateInstance(document.getElementById("example-modal-xl"));
			modal.hide();
		} catch (error) {
			console.error("Submit Error:", error);
		} finally {
			setLoading(false);
		}
	};


	const [ratePlanForm, setRatePlanForm] = useState({
		RatePlanID: 0,
		RatePlan: '',
		PayMode: '',
		MeelPlan: '',
		TaxInclude: false,
		Refundable: false
	});

	const [selectedRoomIndex, setSelectedRoomIndex] = useState(null);
	const [editRatePlanIndex, setEditRatePlanIndex] = useState(null);

	const handleRatePlanSubmit = async (e) => {
		setLoading(true);
		e.preventDefault();
		if (selectedRoomIndex === null || !rooms[selectedRoomIndex]) return alert('Room not selected');

		const payload = {
			...ratePlanForm,
			RoomID: rooms[selectedRoomIndex].RoomID,
			TaxInclude: ratePlanForm.TaxInclude ? "Yes" : "No",
			Refundable: ratePlanForm.Refundable ? "Yes" : "No"
		};

		try {
			const res = await MealPlansave(payload);
			console.log(res);

			swal("Rate Plan Saved successfully", {
				icon: "success",
				buttons: {
					confirm: {
						text: "OK",
						className: "btn btn-success",
					},
				},
			});

			const updatedRooms = [...rooms];
			const room = updatedRooms[selectedRoomIndex];
			const ratePlans = room.RatePlanDetails ? JSON.parse(room.RatePlanDetails) : [];

			if (editRatePlanIndex !== null) {
				ratePlans[editRatePlanIndex] = payload;
			} else {
				ratePlans.push(payload);
			}

			room.RatePlanDetails = JSON.stringify(ratePlans);
			updatedRooms[selectedRoomIndex] = room;

			setRooms(updatedRooms);

			const modal = window.bootstrap.Modal.getOrCreateInstance(document.getElementById("con-close-modal"));
			modal.hide();

			setRatePlanForm({
				RatePlanID: 0,
				RatePlan: '',
				PayMode: '',
				MeelPlan: '',
				TaxInclude: false,
				Refundable: false
			});
			setEditRatePlanIndex(null);
		} catch (err) {
			console.error("Error saving rate plan", err);
			alert("Failed to save rate plan");
		} finally {
			setLoading(false);
		}
	};


	const openEditRatePlan = (roomIndex, planIndex) => {
		setSelectedRoomIndex(roomIndex);
		setEditRatePlanIndex(planIndex);

		// Parse the plan details
		const plans = JSON.parse(rooms[roomIndex].RatePlanDetails || "[]");
		const plan = plans[planIndex];

		setRatePlanForm({
			RatePlanID: plan.RatePlanID || 0,
			RatePlan: plan.RatePlan || '',
			PayMode: plan.PayMode || '',
			MeelPlan: plan.MeelPlan || '',
			TaxInclude: plan.TaxInclude === 'Yes',
			Refundable: plan.Refundable === 'Yes'
		});

		// First hide the view modal
		const viewModal = window.bootstrap.Modal.getInstance(document.getElementById("example-modal-lg"));
		if (viewModal) viewModal.hide();

		// Then show the rate plan modal
		const ratePlanModal = new window.bootstrap.Modal(document.getElementById("con-close-modal"));
		setTimeout(() => {
			ratePlanModal.show();
		}, 300); // slight delay to allow first modal to close
	};









	return (

		<>
			<style>{`
		   table tr td:last-child{
		       text-align: center;  
		   }
		`}</style>
			{loading && (
				<div className="fullscreen-loader">
					<div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
				</div>
			)}

			<div className="wrapper">
				<SideBar />
				<div className="main-panel">
					<Hearder />
					<div className="container">
						<div className="page-inner">
							<div className="row">
								<div className="col-md-12">
									<div className="card">
										<div className="card-header">
											<div className="d-flex justify-content-between">
												<h4 className="card-title">Room Details</h4>
												<button type="button"
													className="btn btn-black btn-sm"
													data-bs-toggle="modal"
													data-bs-target="#example-modal-xl" onClick={() => {
														setFormData(initialFormData);
														setImages([]);
														setIsEditMode(false);
														setEditRoomId(null);
													}} >Add New room</button>
											</div>
										</div>
										<div className="card-body">
											<div className="table-responsive">
												<table
													id="basic-datatables"
													className="display table table-striped table-bordered mt-3 table-hover ">
													<thead>
														<tr>
															<th>Rooms Name</th>
															<th>Description</th>
															<th>Action</th>
															{/* <th>RatePlans</th> */}
															<th></th>
														</tr>
													</thead>

													<tbody>
														{rooms.map((room, index) => (
															<tr key={room.RoomID}>
																<td>{room.RoomName}</td>
																<td>{room.Description}</td>
																<td>
																	<input type="checkbox" checked={room.Active === 1} /> Active

																	<br />
																	{/* <button type="button" className="btn btn-black btn-sm mt-1" data-bs-toggle="modal" data-bs-target="#example-modal-xl" onClick={() => {
																		const room = rooms[index];
																		setFormData(room);
																		setIsEditMode(true);
																		setEditRoomId(room.RoomID);
																	}} >
																		Edit Room
																	</button> */}
																	<button
																		type="button"
																		className="btn btn-black btn-sm mt-1"
																		data-bs-toggle="modal"
																		data-bs-target="#example-modal-xl"
																		onClick={() => {
																			const room = rooms[index];
																			setFormData(room);


																			if (room.RoomPhotoURL) {
																				setImages([{
																					file: null,
																					url: room.RoomPhotoURL
																				}]);
																			} else {
																				setImages([]);
																			}

																			setIsEditMode(true);
																			setEditRoomId(room.RoomID);
																		}}
																	>
																		Edit Room
																	</button>


																</td>
																{/* <td>
																	<button type="button" className="btn btn-black btn-sm waves-effect waves-light " data-bs-toggle="modal" data-bs-target="#con-close-modal" onClick={() => {
																		setSelectedRoomIndex(index);
																		setEditRatePlanIndex(null);
																	}}	>
																		Add Room Rate Plan
																	</button>
																	<br />
																	<button type="button" className="btn btn-black btn-sm mt-1" data-bs-toggle="modal" data-bs-target="#example-modal-lg" onClick={() => setSelectedRoomIndex(index)} >
																		View Details
																	</button>
																</td> */}
																<td>
																	<button className="btn btn-sm btn-danger"><i className="fas fa-trash"></i></button>
																</td>
															</tr>
														))}
													</tbody>
												</table>

											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<>
						<div
							className="modal fade"
							id="example-modal-xl"
							tabIndex={-1}
							aria-labelledby="exampleModalLgLabel"
							aria-hidden="true"
						>
							<div className="modal-dialog modal-xl">
								<div className="modal-content">
									<div className="modal-header">
										<h5 className="modal-title" id="exampleModalLgLabel">
											Room Details
										</h5>
										<button
											type="button"
											className="btn-close"
											data-bs-dismiss="modal"
											aria-label="Close"
										/>
									</div>
									<div className="modal-body">
										<form onSubmit={handleSubmit}>
											<h4 className="card-title">Room Information</h4>
											<div className="row">
												{/* Row 1 */}
												<div className="col-md-4">
													<div className="input-block mb-3">
														<label className="col-form-label">Room Name</label>
														<input type="text" className="form-control" placeholder="Enter room name" value={formData.RoomName}
															onChange={(e) => setFormData({ ...formData, RoomName: e.target.value })} required />
													</div>
												</div>
												<div className="col-md-3">
													<div className="input-block mb-3">
														<label className="col-form-label">Room Type</label>
														<select className="form-control form-select" value={formData.RoomType}
															onChange={(e) => setFormData({ ...formData, RoomType: e.target.value })}>
															<option>Deluxe</option>
															<option>Standard</option>
															<option>Luxury</option>
															<option>Master</option>
															<option>Common</option>
														</select>
													</div>
												</div>
												<div className="col-md-3">
													<div className="input-block mb-3">
														<label className="col-form-label">Bed Type</label>
														<select className="form-control form-select" value={formData.BedType}
															onChange={(e) => setFormData({ ...formData, BedType: e.target.value })}>
															<option>King Bed</option>
															<option>Twin Bed</option>
														</select>
													</div>
												</div>

												{/* Row 2 */}
												<div className="col-md-2">
													<div className="input-block mb-3">
														<label className="col-form-label">Total Rooms</label>
														<input type="number" className="form-control" min="1" defaultValue="1" required value={formData.TotalRooms}
															onChange={(e) => setFormData({ ...formData, TotalRooms: e.target.value })} />
													</div>
												</div>
												<div className="col-md-6">
													<div className="input-block mb-3">
														<label className="col-form-label">Description</label>
														<textarea className="form-control" rows="2" placeholder="Enter description" value={formData.Description}
															onChange={(e) => setFormData({ ...formData, Description: e.target.value })}></textarea>
													</div>
												</div>
												<div className="col-md-2">
													<div className="input-block mb-3">
														<label className="col-form-label">Room View</label>
														<select className="form-control form-select" value={formData.RoomView}
															onChange={(e) => setFormData({ ...formData, RoomView: e.target.value })}>
															<option>No View</option>
															<option>Sea View</option>
															<option>Hill View</option>
														</select>
													</div>
												</div>


												{/* Row 3 */}
												<div className="col-md-2">
													<div className="input-block mb-3">
														<label className="col-form-label">Extra Bed Type</label>
														<select className="form-control form-select" value={formData.ExtraBedType}
															onChange={(e) => setFormData({ ...formData, ExtraBedType: e.target.value })}
														>
															<option>No Extra Bed</option>
															<option>Cot</option>
														</select>
													</div>
												</div>
												<div className="col-md-2">
													<div className="input-block mb-3">
														<label className="col-form-label">Room code</label>
														<input className="form-control" value={formData.RoomCode}
															onChange={(e) => setFormData({ ...formData, RoomCode: e.target.value })} placeholder="Enter Code" />

													</div>
												</div>
											</div>

											<h4 className="card-title">Room Dimensions</h4>
											<div className="row">
												<div className="col-md-6">
													<div className="input-block mb-3">
														<label className="d-block col-form-label">Dimension Type</label>
														<div className="form-check form-check-inline">
															<input className="form-check-input" type="radio" value="Size" name="DimensionsType" checked={formData.DimensionsType === 'Size'}
																onChange={(e) => setFormData({ ...formData, DimensionsType: e.target.value })} />
															<label className="form-check-label">Size</label>
														</div>
														<div className="form-check form-check-inline">
															<input className="form-check-input" type="radio" value="Area" name="DimensionsType" checked={formData.DimensionsType === 'Area'}
																onChange={(e) => setFormData({ ...formData, DimensionsType: e.target.value })} />
															<label className="form-check-label">Area</label>
														</div>
													</div>
													<div className="input-block mb-3 d-flex align-items-center">
														<input className="form-control me-2" type="number" placeholder="Length" value={formData.Length}
															onChange={(e) => setFormData({ ...formData, Length: e.target.value })} />
														<span className="me-2">X</span>
														<input className="form-control me-2" type="number" placeholder="Breadth" value={formData.Breadth}
															onChange={(e) => setFormData({ ...formData, Breadth: e.target.value })} />
														<input className="form-control me-2" type="number" placeholder="Area" value={formData.Area}
															onChange={(e) => setFormData({ ...formData, Area: e.target.value })} />
														<select className="form-control form-select" value={formData.AreaUnit}
															onChange={(e) => setFormData({ ...formData, AreaUnit: e.target.value })}>
															<option>Sq.ft</option>
															<option>Sq.m</option>
														</select>
													</div>
												</div>
											</div>

											<h4 className="card-title">Room Occupancy</h4>
											<div className="row">
												{[
													{ label: 'Adult (Base)', key: 'Adult_Base' },
													{ label: 'Adult (Max)', key: 'Adult_Max' },
													{ label: 'Guest (Max)', key: 'Guest_Max' },
													{ label: 'Child (Base)', key: 'Child_Base' },
													{ label: 'Child (Max)', key: 'Child_Max' }
												].map(({ label, key }) => (
													<div className="col-md-2" key={key}>
														<div className="input-block mb-3">
															<label className="col-form-label">{label}</label>
															<select
																className="form-control form-select"
																value={formData[key]}
																onChange={(e) => setFormData({ ...formData, [key]: parseInt(e.target.value) })}
															>
																{[...Array(21)].map((_, i) => (
																	<option key={`${key}-${i}`} value={i}>{i}</option>
																))}
															</select>
														</div>
													</div>
												))}
											</div>

											<div className='col-12'>
												<div className="d-flex gap-3 flex-wrap">
													{images.map((img, index) => (
														<div key={index} style={{
															width: '89px',
															height: '62px',
															borderRadius: '10px',
															overflow: 'hidden',
															position: 'relative'
														}}>
															<img src={img.url} alt={`preview-${index}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
															<button type="button" onClick={() => removeImage(index)} style={{
																position: 'absolute',
																top: '5px',
																right: '5px',
																background: '#fff',
																border: 'none',
																borderRadius: '50%',
																width: '24px',
																height: '24px',
																padding: 0,
																textAlign: 'center',
																lineHeight: '20px',
																fontWeight: 'bold',
																color: '#333',
																cursor: 'pointer',
																boxShadow: '0 0 5px rgba(0,0,0,0.2)'
															}}>×</button>
														</div>
													))}

													{/* Upload Box */}
													<label htmlFor="imageUpload" style={{
														width: '89px',
														height: '62px',
														border: '2px dashed #ccc',
														borderRadius: '10px',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														cursor: 'pointer'
													}}>
														<div style={{ textAlign: 'center', color: '#999' }}>
															<i className="fas fa-image" style={{ fontSize: '20px' }}></i><br />
															Add Image
														</div>
														<input type="file" id="imageUpload" accept="image/*" multiple onChange={handleImageChange} style={{ display: 'none' }} />
													</label>
												</div>
											</div>

											<div className="text-end mt-3">
												<button type="submit" className="btn btn-primary">Submit</button>
											</div>
										</form>

									</div>
								</div>
							</div>
						</div>

					</>


					<>
						{/*rate plan  modal content */}
						<div
							id="con-close-modal"
							className="modal fade"
							tabIndex={-1}
							role="dialog"
							aria-hidden="true"
							style={{ display: "none" }}
						>
							<div className="modal-dialog">
								<div className="modal-content">
									<div className="modal-header">
										{/* <h4 className="modal-title">Add Room Rate Plan</h4> */}
										<h4 className="modal-title">{editRatePlanIndex !== null ? "Edit" : "Add"} Room Rate Plan</h4>
										<button
											type="button"
											className="btn-close"
											data-bs-dismiss="modal"
											aria-label="Close"
										/>
									</div>
									<div className="modal-body p-4">
										<form onSubmit={handleRatePlanSubmit}>
											<div className="input-block mb-3">
												<label className="col-form-label">Room Rate Plan</label>
												<input type="text" name="RatePlan" className="form-control" placeholder="Enter Rate Plan" value={ratePlanForm.RatePlan}
													onChange={(e) =>
														setRatePlanForm({ ...ratePlanForm, RatePlan: e.target.value })
													} required />
											</div>
											<div className="input-block mb-3">
												<label className="col-form-label">Payment Mode</label>
												<select className="form-control form-select" name="PayMode"
													value={ratePlanForm.PayMode}
													onChange={(e) =>
														setRatePlanForm({ ...ratePlanForm, PayMode: e.target.value })
													}
												>
													<option>Select Mode</option>
													<option value="Pay Now">Pay Now</option>
													<option value="Pay@Hotel">Pay@Hotel</option>
												</select>
											</div>
											<div className="input-block mb-3">
												<label className="col-form-label">Meal Plan</label>
												<select className="form-control form-select" name="MeelPlan"
													value={ratePlanForm.MeelPlan}
													onChange={(e) =>
														setRatePlanForm({ ...ratePlanForm, MeelPlan: e.target.value })
													}>
													<option value="">Select Plan</option>
													<option value="Accommodation only">Accommodation only</option>
													<option value="FREE Breakfast">FREE Breakfast</option>
													<option value="Free Breakfast and Lunch/Dinner">Free Breakfast and Lunch/Dinner</option>
													<option value="FREE Breakfast, Lunch and Dinner">FREE Breakfast, Lunch and Dinner</option>
													<option value="FREE Cooked Breakfast">FREE Cooked Breakfast</option>
													<option value="FREE Breakfast, Lunch, Dinner and Custom Inclusions">FREE Breakfast, Lunch, Dinner and Custom Inclusions</option>
													<option value="FREE Breakfast and lunch">FREE Breakfast and lunch</option>
													<option value="FREE Breakfast and Dinner">FREE Breakfast and Dinner</option>
												</select>
											</div>
											<div className="input-block ">
												<div className="form-check">
													<input type="checkbox" className="form-check-input" id="taxIncluded"
														checked={ratePlanForm.TaxInclude}
														onChange={(e) =>
															setRatePlanForm({ ...ratePlanForm, TaxInclude: e.target.checked })
														} />
													<label className="form-check-label">Tax Included</label>
												</div>
												<div className="form-check">
													<input type="checkbox" className="form-check-input" id="refundable"
														checked={ratePlanForm.Refundable}
														onChange={(e) =>
															setRatePlanForm({ ...ratePlanForm, Refundable: e.target.checked })
														} />
													<label className="form-check-label" >Refundable</label>
												</div>
											</div>
											<div className="text-end">
												{/* <button type="submit" className="btn btn-primary">Submit</button> */}
												<button type="submit" className="btn btn-primary">{editRatePlanIndex !== null ? "Update" : "Save"}</button>
											</div>

										</form>
									</div>

								</div>
							</div>
						</div>
						{/* /rate plan modal */}
					</>


					<>
						{/* view Modal */}
						<div
							className="modal fade"
							id="example-modal-lg"
							tabIndex={-1}
							role="dialog"
							aria-labelledby="myLargeModalLabel"
							aria-hidden="true"
						>
							<div className="modal-dialog modal-lg">
								<div className="modal-content">
									<div className="modal-header">
										<h5 className="modal-title" id="myLargeModalLabel">
											View Rate plan Detail
										</h5>
										<button
											type="button"
											className="btn-close"
											data-bs-dismiss="modal"
											aria-label="Close"
										/>
									</div>
									<div className="modal-body">
										<div className="table-responsive">
											<table className="table table-striped mb-0">
												<thead>
													<tr>
														<th>RatePlan Name</th>
														<th>Meal PLan</th>
														<th>Payment Mode</th>
														<th>Action</th>
													</tr>
												</thead>
												<tbody>
													{selectedRoomIndex !== null &&
														rooms[selectedRoomIndex] &&
														Array.isArray(
															JSON.parse(rooms[selectedRoomIndex].RatePlanDetails || "[]")
														) &&
														JSON.parse(
															rooms[selectedRoomIndex].RatePlanDetails || "[]"
														).map((plan, i) => (
															<tr key={i}>
																<td>{plan.RatePlan}</td>
																<td>{plan.MeelPlan || "-"}</td>
																<td>N/A</td>
																<td>
																	{/* <button type="button" className="btn btn-primary btn-sm waves-effect waves-light mt-1" data-bs-toggle="modal" data-bs-target="#con-close-modal"  >	Edit </button> */}
																	<button className="btn btn-primary btn-sm me-2 py-1 px-2" onClick={() => openEditRatePlan(selectedRoomIndex, i)}><i className="fas fa-edit"></i></button>
																	<button className="btn btn-sm btn-danger py-1 px-2"><i className="fas fa-trash"></i></button>
																</td>
															</tr>
														))}

													{selectedRoomIndex !== null &&
														(!rooms[selectedRoomIndex] ||
															!rooms[selectedRoomIndex].RatePlanDetails ||
															JSON.parse(rooms[selectedRoomIndex].RatePlanDetails || "[]")
																.length === 0) && (
															<tr>
																<td colSpan="4" className="text-center">
																	No Rate Plans Found
																</td>
															</tr>
														)}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* /view Modal */}
					</>
				</div>

			</div>
		</>
	);
};

export default Room;
